import { AdSurveys } from "../types";

export const basic: AdSurveys.Basic = {
  info: [],
};
